<template>
  <pagefra>
    <div
      class="maintainManage container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      element-loading-custom-class="maintain_loading"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <!-- <el-form-item label="所属区域">
              <areaCascader ref="ac" :multiple="true" :checkStrictly="true"></areaCascader>
            </el-form-item> -->
            <el-form-item :label="$l('所属城市')">
              <el-input
                v-model="form.city"
                :placeholder="$l('所属城市')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('大楼名称')">
              <el-input
                v-model="form.buildingName"
                :placeholder="$l('大楼名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('注册代码')">
              <el-input
                v-model="form.registerCode"
                :placeholder="$l('注册代码')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('作业状态')">
              <el-select
                v-model="form.planStatus"
                :placeholder="$l('作业状态')"
              >
                <el-option :label="$l('作业状态')" value></el-option>
                <el-option :label="$l('已计划')" value="已计划"></el-option>
                <el-option :label="$l('已完成')" value="已完成"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item :label="$l('保养单位')">
              <el-select v-model="form.grtFlg" :placeholder="$l('保养单位')">
                <el-option :label="$l('保养单位')" value></el-option>
                <el-option :label="$l('日立电梯')" value="Y"></el-option>
                <el-option :label="$l('非日立保养')" value="N"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item :label="$l('作业时间')">
              <el-date-picker
                v-model="planStartTimeValues"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              round
              icon="el-icon-download"
              @click="exportMainPlan"
              v-if="hasPermission('导出')"
              >{{ $l("导出") }}
            </el-button>
            <!-- <el-radio-group v-model="date">
              <el-radio-button label="top">全部</el-radio-button>
              <el-radio-button label="right">明天 </el-radio-button>
              <el-radio-button label="bottom">今天</el-radio-button>
              <el-radio-button label="left">昨天</el-radio-button>
              <el-radio-button label="33">前天</el-radio-button>
            </el-radio-group> -->
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            :row-style="rowStyle"
          >
            <el-table-column
              :label="$l('序号')"
              type="index"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('梯号')"
              prop="elevatorNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="assetId"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('注册代码')"
              prop="registerCode"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('作业时间')"
              prop="planStartDt"
              align="center"
              min-width="150"
              sortable
              :formatter="formatterPlanStart"
            ></el-table-column>
            <el-table-column
              :label="$l('作业时长(分)')"
              prop="stdTime"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('作业项目')"
              prop="planType"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('作业状态')"
              prop="planStatus"
              align="center"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-tag
                  type="primary"
                  size="medium"
                  effect="plain"
                  round
                  v-if="scope.row.planStatus === '已计划'"
                >
                  {{ scope.row.planStatus }}</el-tag
                >
                <el-tag
                  type="info"
                  size="medium"
                  effect="plain"
                  round
                  v-if="
                    scope.row.planStatus === '已完成' ||
                    scope.row.planStatus === '已审核'
                  "
                  >{{ $l("已完成") }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="作业人员"
              prop="planEmpNames"
              align="center"
              min-width="150"
            ></el-table-column> -->
            <el-table-column
              :label="$l('保养人员')"
              prop="workEmpNames"
              align="center"
              min-width="150"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('保养单位')"
              prop="grtFlg"
              align="center"
              min-width="150"
              :formatter="formatterGrtFlg"
            >
            </el-table-column> -->
            <!-- <el-table-column :label="$l('短信状态')" align="center">
              <template slot-scope="scope">
                <svgicon
                  v-if="!scope.row.smsStatus"
                  name="msg"
                  class="table-icon"
                  min-width="19"
                  height="19"
                ></svgicon>
                <svgicon
                  v-else
                  :original="true"
                  name="msg_recept"
                  class="table-icon"
                  min-width="22"
                  height="19"
                ></svgicon>
              </template>
            </el-table-column> -->
            <el-table-column
              :label="$l('维保监督')"
              align="center"
              v-if="hasPermissionByName('supervise')"
              fixed="right"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="openSupervise(scope.$index, scope.row)"
                  class="table-icon"
                >
                  <svgicon name="monitor" class></svgicon>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('详情')"
              min-width="100"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="showDetail(scope.row.mpId)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('维保评价')"
              min-width="200"
              align="center"
              v-if="hasPermission('维保评价')"
              fixed="right"
            >
              <template slot-scope="scope" v-if="scope.row.grtFlg == 'Y'">
                <!-- <el-rate
                  v-if="scope.row.score > 0"
                  v-model="scope.row.score"
                  disabled
                  show-score
                  :text-color="rateTextColor"
                  :colors="rateColors"
                ></el-rate>-->
                <el-button
                  v-if="scope.row.evaluateStatus"
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="viewEvaluate(scope.$index, scope.row)"
                ></el-button>
                <el-button
                  v-else
                  type="text"
                  icon="el-icon-edit-outline"
                  class="table-icon"
                  @click="openEvaluate(scope.$index, scope.row)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('更新状态')"
              min-width="120"
              header-align="center"
              fixed="right"
              align="center"
              v-if="hasPermission('更新状态')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-refresh"
                  class="table-icon"
                  v-if="scope.row.planStatus == '已计划'"
                  @click="updateStatus(scope.row.mpId)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :title="$l('维保评价')"
        :visible.sync="editEvaluateDialogVisible"
      >
        <el-form
          ref="editEvaluateForm"
          :model="editEvaluateForm"
          :rules="evaluateFormRules"
          label-width="160px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('维保综合满意度')">
            <el-rate
              v-model="editEvaluateForm.overallEval"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="isViewEvaluate"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('电梯运行满意度')">
            <el-rate
              v-model="editEvaluateForm.runEval"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="isViewEvaluate"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('维保人员态度满意度')">
            <el-rate
              v-model="editEvaluateForm.personnelEval"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="isViewEvaluate"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('维保技能满意度')">
            <el-rate
              v-model="editEvaluateForm.skillEval"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="isViewEvaluate"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('其它意见')" prop="remark">
            <el-input
              type="textarea"
              :rows="5"
              v-model="editEvaluateForm.remark"
              :readonly="isViewEvaluate"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$l('追加内容')"
            prop="appendContent"
            v-if="isViewEvaluate"
          >
            <el-input
              type="textarea"
              :rows="5"
              v-model="editEvaluateForm.appendContent"
              :readonly="editEvaluateForm.appendStatus == 1"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="!isViewEvaluate">
          <el-button round @click="editEvaluateDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submitEvaluate"
            >{{ $l("确定") }}
          </el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button
            round
            @click="appendEvaluate"
            v-if="!editEvaluateForm.appendStatus"
            >{{ $l("追加") }}
          </el-button>
          <el-button round @click="editEvaluateDialogVisible = false"
            >{{ $l("关闭") }}
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="$l('维保详情')"
        :visible.sync="detailDialogVisible"
        width="1024px"
      >
        <el-row type="flex">
          <el-col :span="5" :offset="1">
            <h4 class="colname">{{ $l("现场保养图片") }}</h4>
          </el-col>
          <el-col :span="18">
            <div class="imgList">
              <el-image
                :src="item.attach_url"
                :preview-src-list="
                  getPreviewImageList(mainImageList, item, index)
                "
                :z-index="9999"
                v-for="(item, index) in mainImageList"
                :key="index"
              >
                <div slot="error" class="image-slot" @click="viewImage(item)">
                  {{ item.attach_name }}
                </div>
              </el-image>
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row type="flex" align="middle">
          <el-col :span="5" :offset="1">
            <h4 class="colname">{{ $l("客户电子签名") }}</h4>
          </el-col>
          <el-col :span="18">
            <div class="imgList">
              <el-image
                :src="item.attach_url"
                :preview-src-list="
                  getPreviewImageList(signImageList, item, index)
                "
                fit="contain"
                :z-index="9999"
                v-for="(item, index) in signImageList"
                :key="index"
              >
                <div slot="error" class="image-slot" @click="viewImage(item)">
                  {{ item.attach_name }}
                </div>
              </el-image>
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row type="flex" align="middle">
          <el-col :span="5" :offset="1">
            <h4 class="colname">{{ $l("无纸化PDF下载") }}</h4>
          </el-col>
          <el-col :span="18">
            <el-button
              type="primary"
              v-for="(item, index) in pdfList"
              :key="index"
              @click="downloadMainPDF(item)"
              >{{ item.attach_name }}</el-button
            >
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
// import areaCascader from "@/components/areaCascader.vue";
import global from "@/mixins/global.js";
export default {
  name: "maintainManage",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateAppendContent = (rule, value, callback) => {
      if (value == null || value.trim() == "") {
        callback(new Error(this.$l('"请输入追加内容"')));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: this.$l("最近一周"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$l("最近一个月"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$l("最近三个月"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      form: {
        city: "",
        domainName: "",
        jobNum: "",
        buildingName: null,
        registerCode: null,
        planStatus: "已完成",
        grtFlg: "",
        startPlanDate: "",
        endPlanDate: "",
        dataPermissionList: [],
      },
      planStartTimeValues: [],
      tableData: [],
      loading: false,
      initEvaluateForm: {},
      editEvaluateForm: {
        evaluateId: null,
        mpId: "",
        overallEval: null,
        runEval: null,
        personnelEval: null,
        skillEval: null,
        remark: "",
        appendStatus: 0,
        appendContent: "",
      },
      evaluateFormRules: {
        remark: [
          {
            max: 200,
            message: this.$l("长度不能超过 200 个字符"),
            trigger: "blur",
          },
        ],
        appendContent: [
          { validator: validateAppendContent, trigger: "blur" },
          {
            max: 200,
            message: this.$l("长度不能超过 200 个字符"),
            trigger: "blur",
          },
        ],
      },
      editEvaluateDialogVisible: false,
      rateTextColor: "#ff9900",
      rateTexts: [
        this.$l("非常不满意"),
        this.$l("不满意"),
        this.$l("基本满意"),
        this.$l("比较满意"),
        this.$l("十分满意"),
      ],
      isViewEvaluate: false,
      currentEvaluateMpId: "", //当前做维保评价所获取的维保ID
      detailDialogVisible: false,
      mainImageList: [],
      signImageList: [],
      pdfList: [],
      fullLoading: false,
      mpId: "",
    };
  },
  mounted() {
    const query = this.$route.query;
    if (query && query.source == "index") {
      const date = new Date(query.date);
      this.planStartTimeValues = [date, date];
      // this.form.grtFlg = "Y";
      if (query.type == 1) {
        this.form.planStatus = "已计划";
      } else {
        this.form.planStatus = "已完成";
      }
    } else {
      this.planStartTimeValues = this.$common.getDateRange(0);
    }
    if (this.loaded) {
      for (let key in this.editEvaluateForm) {
        this.initEvaluateForm[key] = this.editEvaluateForm[key];
      }
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      if (this.planStartTimeValues && this.planStartTimeValues.length == 2) {
        this.form.startPlanDate = this.$common.formatDate(
          this.planStartTimeValues[0]
        );
        this.form.endPlanDate = this.$common.formatDate(
          this.planStartTimeValues[1]
        );
      } else {
        this.form.startPlanDate = "";
        this.form.endPlanDate = "";
      }
      this.$http
        .post(this.$apiConfig.search_main_plan_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    rowStyle({ row, rowIndex }) {
      if (row.grtFlg === "Y") {
        return "";
      } else {
        return "background: #ddd";
      }
    },
    formatterPlanStart(row) {
      const planStartDt =
        row.planStatus == "已计划" ? row.planStartDt : row.actualStartDt;
      if (planStartDt) {
        return planStartDt.split(" ")[0];
      }
      return "";
    },
    formatterGrtFlg(row) {
      if (row.grtFlg === "Y") {
        return "日立电梯";
      } else {
        return "非日立保养";
      }
    },
    openSupervise(index, row) {
      this.$router.push({
        path: "supervise",
        query: {
          jobNum: row.assetId,
          planStartDt: row.planStartDt ? row.planStartDt.split(" ")[0] : "",
        },
      });
    },
    viewEvaluate(index, row) {
      this.editEvaluateDialogVisible = true;
      this.isViewEvaluate = true;
      this.$http
        .get(this.$apiConfig.get_main_evaluate_url + row.mpId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (let key in this.editEvaluateForm) {
              this.editEvaluateForm[key] = result.data[key];
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    openEvaluate(index, row) {
      this.editEvaluateDialogVisible = true;
      this.isViewEvaluate = false;
      let mpId = row.mpId;
      if (this.currentEvaluateMpId != mpId) {
        for (let key in this.initEvaluateForm) {
          this.editEvaluateForm[key] = this.initEvaluateForm[key];
        }
      }
      this.currentEvaluateMpId = mpId;
      this.editEvaluateForm.mpId = mpId;
    },
    submitEvaluate() {
      if (
        this.editEvaluateForm.runEval == 0 ||
        this.editEvaluateForm.skillEval == 0 ||
        this.editEvaluateForm.personnelEval == 0 ||
        this.editEvaluateForm.overallEval == 0
      ) {
        this.message(1, "请进行评分");
        return;
      }
      this.$refs.editEvaluateForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.$apiConfig.save_main_evaluate_url, this.editEvaluateForm)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.currentEvaluateMpId = "";
                this.editEvaluateDialogVisible = false;
                this.initData();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        }
      });
    },
    appendEvaluate() {
      this.$refs.editEvaluateForm.validate((valid) => {
        if (valid) {
          this.editEvaluateForm.appendStatus = 1;
          this.$http
            .post(this.$apiConfig.save_main_evaluate_url, this.editEvaluateForm)
            .then((response) => {
              this.editEvaluateForm.appendStatus = 0;
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.currentEvaluateMpId = "";
                this.editEvaluateDialogVisible = false;
                this.initData();
              }
            })
            .catch((error) => {
              this.editEvaluateForm.appendStatus = 0;
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        }
      });
    },
    showDetail(mpId) {
      //mpId = "411M5J2";//411M5J0  411M5HZ   411M5HY 3PPY2JX
      if (mpId && this.mpId == mpId) {
        this.detailDialogVisible = true;
        return;
      }
      this.mainImageList = [];
      this.signImageList = [];
      this.pdfList = [];
      this.fullLoading = true;
      this.$http
        .get(this.$apiConfig.get_main_image_list_url, {
          params: {
            mpId: mpId,
          },
        })
        .then((response) => {
          this.fullLoading = false;
          const result = response.data;
          if (result.code == 0) {
            this.mpId = mpId;
            const data = result.data.rtnData;
            if (data.list) {
              data.list.forEach((item, i) => {
                item.attach_url = "";
                if (item.attach_type == "1") {
                  this.signImageList.push(item);
                } else if (item.attach_type == "2") {
                  this.pdfList.push(item);
                } else {
                  this.mainImageList.push(item);
                }
              });
            }
            let msg = "";
            let count = 0;
            if (this.mainImageList.length == 0) {
              msg += this.$l("现场保养图片不存在") + "<br/>";
              count++;
            }
            if (this.signImageList.length == 0) {
              msg += this.$l("客户电子签名不存在") + "<br/>";
              count++;
            }
            if (this.pdfList.length == 0) {
              msg += this.$l("无纸化PDF不存在") + "<br/>";
              count++;
            }
            if (count < 3) {
              this.detailDialogVisible = true;
            } else {
              this.mpId = null;
            }
            if (msg) {
              this.message(1, msg);
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.message(1, "获取失败");
          this.$sentry.captureException(error);
        });
    },
    getPreviewImageList(imageList, item, index) {
      const arr = imageList.filter((t) => t.attach_url.length > 0);
      if (arr.length > 0) {
        index = arr.findIndex((t) => t.attach_id == item.attach_id);
        let result = arr.map((t) => t.attach_url).slice(index);
        const tempArr = arr.map((t) => t.attach_url).slice(0, index);
        return result.concat(tempArr);
      }
      return [];
    },
    viewImage(item) {
      this.fullLoading = true;
      this.$http
        .get(this.$apiConfig.get_main_image_url, {
          params: {
            attachId: item.attach_id,
            attachType: item.attach_type,
          },
        })
        .then((response) => {
          this.fullLoading = false;
          const result = response.data;
          if (result.code == 0) {
            let data = result.data.rtnData.attach_base64;
            if (!data) {
              this.message(1, "图片不存在");
            } else {
              data = "data:image/jpg;base64," + data;
              if (item.attach_type == "3") {
                for (let i = 0; i < this.mainImageList.length; i++) {
                  let image = this.mainImageList[i];
                  if (image.attach_id == item.attach_id) {
                    image.attach_url = data;
                  }
                }
              } else if (item.attach_type == "1") {
                for (let i = 0; i < this.signImageList.length; i++) {
                  let image = this.signImageList[i];
                  if (image.attach_id == item.attach_id) {
                    image.attach_url = data;
                  }
                }
              }
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.message(1, "获取失败");
          this.$sentry.captureException(error);
        });
    },
    downloadMainPDF(item) {
      this.fullLoading = true;
      this.$http({
        url:
          this.$apiConfig.get_main_pdf_url +
          "?attachId=" +
          item.attach_id +
          "&attachName=" +
          item.attach_name +
          "&attachType=" +
          item.attach_type,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          this.fullLoading = false;
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, item.attach_name + ".pdf");
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = item.attach_name + ".pdf";
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    exportMainPlan() {
      if (this.planStartTimeValues && this.planStartTimeValues.length == 2) {
        this.form.startPlanDate = this.$common.formatDate(
          this.planStartTimeValues[0]
        );
        this.form.endPlanDate = this.$common.formatDate(
          this.planStartTimeValues[1]
        );
      } else {
        this.form.startPlanDate = "";
        this.form.endPlanDate = "";
      }
      this.fullLoading = true;
      let filename =
        "无纸化保养记录_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      this.$http({
        url: this.$apiConfig.export_main_plan_url,
        method: "post",
        responseType: "blob",
        data: this.form,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    updateStatus(mpId) {
      this.fullLoading = true;
      this.$http
        .post(`${this.$apiConfig.update_main_plan_status_url}/${mpId}`)
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            const data = result.data;
            for (let i = 0; i < this.tableData.length; i++) {
              let item = this.tableData[i];
              if (item.mpId == data.mpId) {
                item.planStatus = data.planStatus;
              }
            }
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>
<style>
.maintain_loading {
  z-index: 9999 !important;
}
.el-message--error {
  z-index: 9999 !important;
}
</style>
<style lang="scss" scoped>
.el-table .gray-row {
  background: #cccccc;
}
.maintainManage {
  .el-radio-group {
  }

  /deep/ .el-radio-button__inner {
    padding: 0px 15px;
    margin: 9px 0;
    border-top: 0;
    border-bottom: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-color: $--border-color-base;
    box-shadow: none;
    background-color: transparent;
    color: $--color-primary;
  }
  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-left: 0;
  }
  /deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-right: 0;
  }

  .dialog-form {
    .el-textarea {
      width: 400px;
      border-radius: 0em;
    }
    /deep/ .el-textarea__inner {
      border-radius: 1em;
    }
    .el-rate {
      width: 400px;
      margin-top: 8px;
      margin-left: 20px;
    }
  }
}
.imgList {
  display: flex;
  flex-wrap: wrap;
  margin: 1em 0;
  .el-image {
    width: 200px;
    height: 150px;
    margin-right: 25px;
    margin-bottom: 25px;
    // background: #cccccc;
    border: 1px solid #ccc;
    /deep/ .image-slot {
      height: 150px;
      line-height: 150px;
      text-align: center;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
/deep/ .el-image-viewer__mask {
  opacity: 1;
  background: #fff;
}
</style>
